import React from 'react';

export default function NewEmployeeRegistration() {
  return (
    <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <iframe src="https://little-seahorse-297.notion.site/ebd//2c31928df74d8037ab6ffb527a5c75ed" width="100%" height="100%" frameBorder="0" allowFullScreen title="New Employee Registration" />
    </div>
  );
}
